module.exports = __webpack_public_path__ + "img/main-reading-area.997326b4.jpg";